<template>
  <a-row :gutter="20">
    <a-col :span="selectedRowKeys.length > 0 ? 12 : 12">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form class="div-query-banner" layout="inline" @keyup.enter.native="searchQuery">
            <a-form-item label="应用名称">
              <j-input placeholder="请输入应用名称" v-model="queryParam.name"></j-input>
            </a-form-item>
            <a-form-item label="负责人工号">
              <j-input placeholder="请输入负责人工号" v-model="queryParam.manager"></j-input>
            </a-form-item>
            <template v-if="toggleSearchStatus">
              <a-form-item label="备注">
                <a-input placeholder="请输入备注" v-model="queryParam.remarks"></a-input>
              </a-form-item>
              <a-form-item label="是否启用">
                <a-input placeholder="请输入是否启用" v-model="queryParam.izActivity"></a-input>
              </a-form-item>
            </template>
            <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
            <a-button class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            <a @click="handleToggleSearch" style="margin-left: 8px">
              {{ toggleSearchStatus ? '收起' : '展开' }}
              <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
            </a>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <a-button @click="handleOpenServiceList" type="primary" icon="plus">添加依赖服务</a-button>
          <a-button @click="handleOpenServerList" type="primary" icon="plus">选择服务器</a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
            >项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :scroll="{ x: true }"
            :loading="loading"
            :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
            :customRow="customRow"
            @change="handleTableChange"
          >
           <template slot="izActivity" slot-scope="text">
              <span v-if="text === 1" class="green">启用</span>
              <span v-if="text === 0" class="red">禁用</span>
            </template>
           <template slot="hrefToUrl" slot-scope="text">
              <a @click="jumpToPage(text)">{{text}}</a>
            </template>
            <span slot="action" slot-scope="text, record">
              <!-- <a @click="handleStart(record.id)">启动步骤</a> -->
               <!-- <a-divider type="vertical" /> -->
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </div>
        <busServermanageApp-modal ref="modalForm" @ok="modalFormOk"></busServermanageApp-modal>
        <select-service-modal ref="selectServiceModal" @select="handleServiceSelected"></select-service-modal>
        <select-server-modal  ref="selectServerModal" @select="handleServerSelected" ></select-server-modal>
       <!-- <start-step-modal  ref="startStepModal"  ></start-step-modal> -->
      </a-card>
    </a-col>
    <a-col v-if="selectedRowKeys.length > 0" :span="12" style="height:800px;">
      <a-row style="height: 50%;">
        <service-list :title="serviceTitle" ref="serviceList" :appId="selectedRowKeys[0]"></service-list>
      </a-row>
      <a-row style="height: 50%;">
        <server-list :title="serviceTitle" ref="serverList" :appId="selectedRowKeys[0]"></server-list>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusServermanageAppModal from './modules/BusServermanageAppModal'
import ServiceList from './components/ServiceList.vue'
import ServerList from './components/ServerList'
import SelectServiceModal from './modules/SelectServiceModal.vue'
import SelectServerModal from './modules/SelectServerModal.vue'
import { addAppByServiceId ,addServerByAppId } from '@/api/api.js'
// import StartStepModal from './modules/StartStepModal.vue'
import JInput from '@/components/jeecg/JInput.vue'
export default {
  name: 'BusServermanageAppList',
  mixins: [JeecgListMixin],
  components: {
    JInput,
    BusServermanageAppModal,
    ServiceList,
    ServerList,
    SelectServiceModal,
    SelectServerModal,
    // StartStepModal
  },
  data() {
    return {
      description: '服务器管理______应用表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '应用名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '负责人工号',
          align: 'center',
          dataIndex: 'manager_dictText',
          
        },
        {
          title: '流水线部署地址',
          align: 'center',
          dataIndex: 'deploytoolUrl',
          scopedSlots: { customRender: 'hrefToUrl' }
        },
        {
          title: '代码仓库地址',
          align: 'center',
          dataIndex: 'codeUrl',
        },
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'remarks',
        },
        {
          title: '是否启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: { customRender: 'izActivity' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        },
      ],
      url: {
        list: '/servermanage/busServermanageApp/list',
        delete: '/servermanage/busServermanageApp/delete',
        deleteBatch: '/servermanage/busServermanageApp/deleteBatch',
        exportXlsUrl: '/servermanage/busServermanageApp/exportXls',
        importExcelUrl: 'servermanage/busServermanageApp/importExcel',
      },
      dictOptions: {},
      serviceTitle: '',
      customRow: (record) => {
        return {
          on: {
            click: () => {
              this.onSelectChange([record.id], [record])
            },
          },
        }
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
    handleServiceSelected(serviceIds) {
      if (serviceIds && serviceIds.length > 0) {
        addAppByServiceId({ serviceIds: serviceIds, appId: this.selectedRowKeys[0] })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success(res.message)
              this.$refs.serviceList.loadData()
            } else {
              this.$message.error(res.message)
            }
          })
          .catch((err) => {
            if (err && err.message) {
              this.$message.error(err.message)
            }
          })
      }
    },
    // 应用添加服务器
    handleServerSelected(serverIds) {
      if (serverIds && serverIds.length > 0) {
        console.log(serverIds)
        addServerByAppId({ serverIds: serverIds, appId: this.selectedRowKeys[0] })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success(res.message)
              this.$refs.serverList.loadData()
            } else {
              this.$message.error(res.message)
            }
          })
          .catch((err) => {
            if (err && err.message) {
              this.$message.error(err.message)
            }
          })
      }
    },

    handleOpenServiceList() {
      if (this.selectedRowKeys == 0 || this.selectionRows == 0) {
        this.$message.error('请选择一个应用')
        return
      }
      this.serviceTitle = '为' + this.selectionRows[0].name + '添加服务'
      console.log(this.serviceTitle)
      this.$refs.selectServiceModal.open()
    },
    // 选择服务器
    handleOpenServerList() {
      if (this.selectedRowKeys == 0 || this.selectionRows == 0) {
        this.$message.error('请选择一个应用')
        return
      }
      this.serviceTitle = '为' + this.selectionRows[0].name + '选择服务器'
      console.log(this.serviceTitle)
      this.$refs.selectServerModal.open()
    },
    // handleStart(appId){
    //   this.$refs.startStepModal.open(appId,2);
    // },
    jumpToPage(url){
      window.open(url)
    }
  },
  watch: {
    dataSource(newVal) {
      if (!newVal[0]) {
        return
      }
      this.onSelectChange([newVal[0].id], [newVal[0]])
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.red {
  color: red;
}
.green {
  color: green;
}
.card-class {
  min-height: 900px;
}
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(n) {
    width: 300px;
  }
  & > *:nth-child(n + 2) {
    margin-left: 12px;
  }
  & > .ant-btn {
    width: 100px;
  }
  & > a{
    width: 60px;
    height: 30px;
  }
}
</style>